import React, { useState, useEffect } from "react";
import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/TopBar";
import "./index.css";
import CounsellorCounter from "./CounsellorCounter";
import CounsellorList from "./CounsellorList";
import { useDispatch, useSelector } from "react-redux";
import { getCounsellorList } from "../../api/Data/Counsellor";
export default function Index() {
  const dispatch = useDispatch();
  const [totalStudent, setTotal] = useState(0);
  const [activeStudent, setActive] = useState(0);
  const [inactive, setInactive] = useState(0);
  const [collapsed, setCollapsed] = useState(false);
  const getStudentLists = () => {
    let token = localStorage.getItem("token");
    dispatch(getCounsellorList("Bearer " + token)).then((res) => {
      console.log(res.payload.data.payload.data);
      if (Array.isArray(res.payload.data.payload.data)) {
        let arr = res.payload.data.payload.data;
        let totalLen = arr.length;
        let activeArr = arr.filter((item) => item.status === "ACTIVE");
        let inactiveArr = arr.filter((item) => item.status !== "ACTIVE");
        setTotal(totalLen);
        setActive(activeArr.length);
        setInactive(inactiveArr.length);
      }
    });
  };

  useEffect(() => {
    getStudentLists();
  });
  return (
    <div className="fixed inset-x-0 bottom-0 top-16 flex bg-[#F8FAFC] overflow-hidden">
      <TopBar />

      {/* Sidebar */}
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-screen z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      <div
        className={`flex-1 min-w-0 overflow-auto bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${
          collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
        }`}
      >
        <div className="p-4 md:p-6 bg-[#FFFFFF] min-h-screen rounded-2xl font-poppins">
          <CounsellorCounter
            totalStudent={totalStudent}
            activeStudent={activeStudent}
            inactive={inactive}
          />
          <div className="w-full">
            <CounsellorList getStudentListsData={getStudentLists} />
          </div>
        </div>
      </div>
    </div>
  );
}
